import FilterColumn from "../shared/FilterColumn"
import { MultipleInputsFilterProps } from "../types"


const MultipleInputsFilter = ({ columns }: MultipleInputsFilterProps) => {
    return (
        <div className='flex w-full'>
            {columns.map((column) => (
                <FilterColumn key={column.title} {...column} />
            ))}
        </div>
    )
}

export default MultipleInputsFilter